<template>
  <div
    class="text-with-image-inline"
    :class="component_classes">
    <div
      class="position-relative text-with-image-inline__img-block"
      :class="{img_right: img_right}">
      <lazy-image
        :src="img_src"
        :lazy_src="lazy_img_src"
        :img_border_radius="img_border_radius"/>
    </div>
    <div class="text-with-image__content">
      <default-title
        v-if="title"
        :title="title"
        :title_tag="title_tag"
        :upper_case="title_upper_case"
        :pre_wrap="title_pre_wrap"
        class="text-with-image-inline__title"
        :class="inline_title_classes"
      />
      <div v-if="sub_title" class="text-with-image-inline__sub-title">
        {{sub_title}}
      </div>
      <div class="text-with-image-inline__text-block">
        <html-block
          v-if="content"
          class="text-with-image-inline__text"
          :content="content"
        />
        <div
          v-if="has_button && !getIsMobile"
          class="text-with-image-inline__link">
          <default-button
            :is_light="!button_green"
            bordered
            :href="button_link">
            {{ button_text }}
          </default-button>
        </div>
        <slot></slot>
      </div>
    </div>
    <div
      v-if="has_button && getIsMobile"
      class="text-with-image-inline__link">
      <default-button
        :is_light="!button_green"
        bordered
        :href="button_link">
        {{ button_text }}
      </default-button>
    </div>
  </div>
</template>

<script>

import LazyImage from "../../small_parts/LazyImage.vue";
import WaveSmallerIcon from "../../fill_svg/WaveSmallerIcon.vue";
import ArrowRightIcon from "../../icons/ArrowRightIcon.vue";
import ArrowTextHover from "../../small_parts/ArrowTextHover.vue";
import DefaultButton from "../../slots/DefaultButton.vue";
import DefaultTitle from "../../small_parts/DefaultTitle.vue";
import HtmlBlock from "../../small_parts/HtmlBlock.vue";
import {mapGetters} from "vuex";

export default {
  name: "TextWithImageInline",
  components: {
    HtmlBlock,
    DefaultTitle,
    DefaultButton,
    ArrowTextHover,
    ArrowRightIcon,
    WaveSmallerIcon,
    LazyImage,
  },
  props: {
    img_src: {
      type: String,
      default: '',
    },
    lazy_img_src: {
      type: String,
      default: '',
    },
    img_border_radius: {
      type: Boolean,
      default: false,
    },
    sub_title: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    title_tag: {
      type: String,
      default: 'h1',
    },
    title_upper_case: {
      type: Boolean,
      default: false,
    },
    title_pre_wrap: {
      type: Boolean,
      default: false,
    },
    content: {
      type: String,
      default: '',
    },
    button_text: {
      type: String,
      default: '',
    },
    button_link: {
      type: String,
      default: '',
    },
    button_green: {
      type: Boolean,
      default: false,
    },
    text_centered: {
      type: Boolean,
      default: false,
    },
    title_on_center: {
      type: Boolean,
      default: false,
    },
    img_right: {
      type: Boolean,
      default: false,
    },
    mobile_image_from_top: {
      type: Boolean,
      default: false,
    },
    mobile_image_from_bottom: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters([
      'getIsMobile',
    ]),
    inline_title_classes() {
      return {
        centered: this.title_on_center
      }
    },
    has_button() {
      return this.button_text && this.button_link
    },
    component_classes() {
      return {
        text_center: this.text_centered,
        xs_top_image: this.mobile_image_from_top,
        xs_bottom_image: this.mobile_image_from_bottom,
      }
    }
  }
}
</script>
